import axios from 'axios';
import { after, before } from './interceptor';
export var createRequest = function (config, commonParams) {
    var baseURL = (config || {}).baseURL;
    var xhr = axios.create({
        baseURL: baseURL || window.location.origin,
        withCredentials: true,
    });
    xhr.interceptors.request.use(function (requestConfig) {
        return before(requestConfig, commonParams || {});
    }, undefined);
    xhr.interceptors.response.use(function (responseConfig) {
        return after(responseConfig);
    }, undefined);
    return xhr;
};
